import { useState, useCallback } from "react";
import { CLEAR_ALL_CLICKED } from "constants/bigbrain-event-types";
import { componentStyles } from "./filters.scss";
import Filter from "./filter/filter";
import { trackEvent } from "/services/bigbrain-service";
import SearchIcon from "/static/svg/search.svg";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";

const WhatsNewPageFilters = ({
  filtersSchema,
  filterValues,
  onChange,
  setFilterValues,
  handleTextSearchChange,
  textSearch
}) => {
  const [openFilterId, setOpenFilterId] = useState(null);

  const clearFilters = () => {
    setOpenFilterId(null);
  };

  const handleToggleFilter = useCallback(
    (id) => {
      if (openFilterId === id) {
        clearFilters();
      } else {
        setOpenFilterId(id);
      }
    },
    [openFilterId]
  );

  const handleClearAllFilters = () => {
    const newFilterValues = {};
    filtersSchema.forEach(({ id }) => {
      newFilterValues[id] = [];
    });
    onChange(newFilterValues);
    setFilterValues(newFilterValues);
    clearFilters();
    handleTextSearchChange({ target: { value: "" } });
    trackEvent(CLEAR_ALL_CLICKED);
  };

  const handleFiltersChange = (id, values) => {
    const newFilterValues = {
      ...filterValues,
      [id]: values
    };
    onChange(newFilterValues);
  };

  return (
    <div className="filters-container">
      <div className="filters-content">
        <div className="text-filter-container">
          <div className="search-icon-wrapper">
            <SearchIcon />
          </div>
          <input type="text" placeholder="Search" value={textSearch} onChange={handleTextSearchChange} />
        </div>
        <div className="filters-title">
          <h2>Filters</h2>
          <div
            className="clear-all"
            onClick={handleClearAllFilters}
            onKeyDown={generateOnKeyDownHandler(() => {
              handleClearAllFilters();
            })}
            tabIndex={0}
            role="button"
          >
            Clear all
          </div>
        </div>
        {filtersSchema.map(({ id, title, data }) => (
          <Filter
            key={`${id}-${JSON.stringify(filterValues)}`}
            id={id}
            title={title}
            data={data}
            values={filterValues[id]}
            isOpen={openFilterId === id}
            onToggle={() => handleToggleFilter(id)}
            onChange={(values) => handleFiltersChange(id, values)}
          />
        ))}
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default WhatsNewPageFilters;
